import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { FormattedMessage } from 'react-intl'
import SettingsIcon from 'components/icons/SettingsIcon.svg'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import pickBy from 'lodash/pickBy'
import { Typography } from '@mui/material'
import sx from './styles'

const FilterButton = ({ onClick }) => {
  const { filters } = useSelector((s) => s.map)
  return (
    <Box sx={sx.root}>
      <Button
        onClick={onClick}
        sx={sx.button}
        startIcon={<SettingsIcon />}
        className="slim"
      >
        <FormattedMessage id="FILTERS" />
        {!isEmpty(pickBy({ ...filters, body: null })) && (
          <Box
            sx={sx.chip}
            component="span"
          >
            <Typography
              variant="quote"
            >
              {Object.keys(pickBy({ ...filters, body: null })).length}
            </Typography>
          </Box>
        )}
      </Button>
    </Box>
  )
}

export default memo(FilterButton)
